import { Action } from '@ngrx/store';
import {
    CreateOrganizationAccount201Response,
    CreateUserAccount201Response,
} from '@viewbid/ts-angular-client';
export interface GenericActionPayload {
    data: string;
}

export enum CreateProfileServiceActions {
    AccountCreated = '[Create Profile Service] Account Created',
    AccountCreationFailed = '[Create Profile Service] Account Creation Failed',
}

export type AccountCreatedActionProps =
    | CreateOrganizationAccount201Response
    | CreateUserAccount201Response;

export class AccountCreatedAction implements Action {
    readonly type: CreateProfileServiceActions =
        CreateProfileServiceActions.AccountCreated;
    readonly props: AccountCreatedActionProps;

    constructor(props: AccountCreatedActionProps) {
        this.props = props;
    }
}

export class AccountCreationFailedActionProps extends Error {
    constructor(public override message: string) {
        super(message);
        this.name = 'AccountCreationFailedActionProps';
        this.message = message;
        this.stack = (<any>new Error()).stack;
    }

    override toString(): string {
        return this.name + ': ' + this.message;
    }
}

export class AccountCreationFailedAction implements Action {
    readonly type: CreateProfileServiceActions =
        CreateProfileServiceActions.AccountCreationFailed;
    readonly props: AccountCreationFailedActionProps;

    constructor(props: AccountCreationFailedActionProps) {
        this.props = props;
    }
}
